"use strict";module.exports = {
  _L_: new WeakMap(),
  _K_: new WeakMap(),
  _p_: new WeakMap(),
  aW_: new WeakMap(),
  _n_: new WeakMap(),
  _o_: {}
};